// Script availability is independent of annotation saving and offline-copy preparation.
import { signal } from "@preact/signals";

export type ScriptStage = "opening" | "loading" | "preparing" | "ready" | "error";
export const scriptLoad = signal<{
  stage: ScriptStage;
  startedAt: number;
  loaded?: number;
  total?: number;
  error?: string;
}>({ stage: "opening", startedAt: performance.now() });

/** Installed by the viewer once; retry never reloads show data or discards a draft. */
export const retryScript = signal<(() => void) | null>(null);
